{
  "handsLicenseFilterBar": {
    "placeholder": "Search by area or camera name"
  },
  "handsLicenseStatusChip": {
    "text": "In use",
    "text2": "Unused",
    "text3": "App pending"
  },
  "handsLicenseTable": {
    "enqueueSnackbar": "The memo couldn't be updated.",
    "enqueueSnackbar2": "The license couldn't be assigned.",
    "enqueueSnackbar3": "License unassigned",
    "enqueueSnackbar4": "The license couldn't be unassigned.",
    "enqueueSnackbar5": "The license couldn't be reassigned.",
    "label": "Area",
    "label2": "Camera",
    "label3": "Memo",
    "label4": "Status",
    "label5": "Start date",
    "label6": "Assignment",
    "text": "No licenses available to view"
  },
  "handsLicenseTableHeader": {
    "text": " licenses"
  },
  "handsLicensesView": {
    "title": "License management"
  },
  "licenseAssignDialog": {
    "title": "Assign license",
    "text": "Select the area and camera to assign the license to.",
    "text2": "No areas are available for assignment.",
    "label": "Area",
    "placeholder": "Select an area",
    "label2": "Camera name",
    "placeholder2": "Enter a camera name",
    "button": "Assign"
  },
  "licenseAssignSuccessDialog": {
    "licenseActionText": "The license was assigned.",
    "title": "License assignment complete"
  },
  "licenseReassignDialog": {
    "text": "Reassign the license?",
    "text2": " will be reassigned.",
    "text3": "Area name: ",
    "text4": "Camera name: ",
    "text5": "Reassigning renews only the license key.",
    "text6": "As a result, the app is deauthorized, the service stops, and the status returns to \"App pending\".",
    "button": "Reassign"
  },
  "licenseReassignSuccessDialog": {
    "licenseActionText": "The license was reassigned.",
    "title": "License reassignment complete"
  },
  "licenseSuccessDialog": {
    "text": "The license key couldn't be retrieved.",
    "enqueueSnackbar": "License key copied",
    "enqueueSnackbar2": "The license key couldn't be copied.",
    "text2": "/",
    "text3": "— ",
    "text4": "License key",
    "button": "Copy",
    "button2": "OK"
  },
  "licenseUnassignDialog": {
    "text": "Unassign the license?",
    "text2": "The following license will be unassigned.",
    "text3": "Assigned to",
    "text5": "Cloud recording data will be deleted",
    "text6": "Resetting automatically deletes the cloud recording data for this camera. This action can't be undone.",
    "text7": "* View permissions will be reset.",
    "text8": "* Hands recordings and AI detection results aren't deleted. They're kept and can be viewed only by administrators.",
    "button": "Unassign"
  },
  "memoEditDialog": {
    "helperText": "{{length}}/500 characters",
    "label": "Memo",
    "placeholder": "Enter a memo...",
    "button": "Reset",
    "button2": "Reassign"
  }
}
